module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "file-manager"
  }, [_c('div', {
    staticClass: "mask"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "dlgdrag",
      rawName: "v-dlgdrag"
    }],
    staticClass: "dig"
  }, [_c('div', {
    staticClass: "dig_title clearFix"
  }, [_vm._m(0), _vm._v(" "), _c('Icon', {
    staticClass: "fr",
    attrs: {
      "type": "close-round"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.dialogClose($event)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dig-main clearFix artical-file-dig-main"
  }, [_c('div', {
    staticClass: "main-left main-left-table",
    staticStyle: {
      "right": "0px",
      "padding-right": "20px"
    }
  }, [_c('div', {
    staticClass: "tab_content",
    staticStyle: {
      "margin-top": "50px"
    }
  }, [_c('div', {
    directives: [{
      name: "bar",
      rawName: "v-bar",
      value: ({
        preventParentScroll: true,
        scrollThrottle: 30
      }),
      expression: "{preventParentScroll: true,scrollThrottle: 30}"
    }],
    ref: "tabul",
    staticClass: "artical_tab_ul"
  }, [_c('div', {
    staticClass: "artical_tab_li",
    staticStyle: {
      "font-size": "14px"
    }
  }, [_c('ul', {
    staticClass: "main-left-list clearFix"
  }, [_vm._l((_vm.products), function(product) {
    return _c('li', {
      key: product.id,
      staticClass: "list-li fl",
      on: {
        "click": function($event) {
          _vm.selectedPrdById(product.id)
        }
      }
    }, [_c('div', {
      staticClass: "list-li-top",
      class: {
        selected: _vm.selectedArr.findIndex(function (v) { return v == product.id; }) > -1
      },
      staticStyle: {
        "height": "60px",
        "position": "relative"
      }
    }, [_c('img', {
      attrs: {
        "src": product.thumb
      }
    }), _vm._v(" "), _vm._m(1, true)]), _vm._v(" "), _c('div', {
      staticClass: "list-li-bottom"
    }, [
      [_vm._v(_vm._s(product.name))]
    ], 2)])
  }), _vm._v(" "), (!_vm.products.length) ? _c('li', {
    staticClass: "list-li fl",
    staticStyle: {
      "color": "#f00",
      "width": "150px"
    }
  }, [_vm._v("未找到匹配的产品")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "confirm_btn",
    staticStyle: {
      "bottom": "25px"
    },
    on: {
      "click": _vm.selectedProduct
    }
  }, [_vm._v("确定(" + _vm._s(_vm.selectedArr.length) + ")")]), _vm._v(" "), _c('div', {
    staticClass: "file_category_box"
  }, [_c('div', {
    staticClass: "fr"
  }, [_c('Input', {
    attrs: {
      "placeholder": "按产品名称查找"
    },
    model: {
      value: (_vm.keyword),
      callback: function($$v) {
        _vm.keyword = $$v
      },
      expression: "keyword"
    }
  }, [_c('Button', {
    attrs: {
      "slot": "append",
      "icon": "ios-search"
    },
    on: {
      "click": _vm.searchProduct
    },
    slot: "append"
  })], 1)], 1)])])]), _vm._v(" "), _c('Page', {
    staticClass: "pager",
    attrs: {
      "total": _vm.total,
      "page-size": _vm.pagesize,
      "size": "small"
    },
    on: {
      "on-change": _vm.onPager
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fl"
  }, [_c('b', {
    staticClass: "mark_choose"
  }), _vm._v("选择产品")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "selectState"
  }, [_c('span', {
    staticClass: "iconfont icon-dui",
    staticStyle: {
      "font-size": "32px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-d3eabaa0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/wxplugins/product_list/product_selector.vue
// module id = 196
// module chunks = 2